import gsap from 'gsap';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import InterfaceCanvas from '../_app/cuchillo/layout/InterfaceCanvas';
import BGVideo from '../layout/BGVideo';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';

export default class Project extends Default {
  timeline;
  projects;
  images = [];
  canvas;
  isEnabled = false;
  overlay;

  calls = {
    hover: (e) => this.hover(e.target),
    out: (e) => this.out(e.target),
    // loop: () => this.loop()
  }

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();

    this.overlay = GetBy.class('__overlay', this.container)[0];
    this.projects = [...GetBy.class('__line')];
    this.setupAnimation();
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.directShow();
      Preloader.hide(() => { this.showList() });
    } else {
      Wrap.directShow();
      this.showList();
    }
  }

  showList() {
    this.timeline.restart();
    setTimeout(() => { this.isEnabled = true }, 800);
    this.afterShow();
  }

  afterShow() {
    super.afterShow();
  }

  setupAnimation() {
    this.timeline = gsap.timeline({ paused: true });
    let delay = 0;
    let cont = 0;
    let index = 0;

    this.projects.map(project => {
      this.timeline.from(project, {
        alpha: 0,
        duration: .1,
        force3D: true
      }, delay);
      //delay += .02;
      delay += Math.max(.02, .02 - .01 * cont);

      //delay += .02;
      index++;
      cont += Math.min(1, .5 * index * index);

      project.addEventListener(Basics.mouseOver, this.calls.hover);
      project.addEventListener(Basics.mouseOut, this.calls.out);
    });
  }

  hover(target) {
    if (isMobile || !this.isEnabled) return;

    clearTimeout(this.idTimerOut);
    BGVideo.play(target.getAttribute('data-hover-video'));
  }

  out() {
    if (isMobile) return;

    this.idTimerOut = setTimeout(() => {
      BGVideo.hide();
    }, 150);
  }

  dispose() {
    clearTimeout(this.idTimerOut);

    this.projects.map(project => {
      project.removeEventListener(Basics.mouseOver, this.calls.hover);
      project.removeEventListener(Basics.mouseOut, this.calls.out);
    });
    super.dispose();
  }

  resize() {
    super.resize();

    if (isMobile) return;

    let r = 150;
    if (Metrics.ASPECT > 1) r = Math.floor(Metrics.HEIGHT * 0.4);
    else r = Math.floor(Metrics.WIDTH * 0.4);

    this.overlay.style.setProperty('--r', r + 'px');
  }
}

ControllerPage._addPage("page-projects", Project)